define("shared/utils/constants/days", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  const days = intl => [{
    wday: 0,
    name: intl.t('days.sunday')
  }, {
    wday: 1,
    name: intl.t('days.monday')
  }, {
    wday: 2,
    name: intl.t('days.tuesday')
  }, {
    wday: 3,
    name: intl.t('days.wednesday')
  }, {
    wday: 4,
    name: intl.t('days.thursday')
  }, {
    wday: 5,
    name: intl.t('days.friday')
  }, {
    wday: 6,
    name: intl.t('days.saturday')
  }];
  var _default = _exports.default = days;
});